import toast from "react-hot-toast";

const { clientAPI } = require("../client");
export const lockingRelativeParticipantCall = {
  create: async (data) => {
    try {
      const response = await clientAPI(
        "post",
        "/lockingRelativeParticipant",
        data
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  createAndUpdateMany: async (data) => {
    try {
      const response = await clientAPI(
        "post",
        "/lockingRelativeParticipant/bulk",
        data
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI(
        "put",
        `/lockingRelativeParticipant/${id}`,
        data
      );
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI(
        "delete",
        `/lockingRelativeParticipant/${id}`
      );
      return response;
    } catch (error) {
      console.error("Delete error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getAll: async () => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant?page=1&limit=9999`
      );
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getByLockingId: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant?lockingId=${id}&page=1&limit=9999`
      );

      let mappedData = null;
      if (response?.items) {
        mappedData = response?.items.map((item) => ({
          employeeName: item?.employee?.fullName || "",
          isCollaborator: item?.isCollaborator,
          relativeName: item?.relative?.fullName || "-",
        }));
      }

      return mappedData;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getGroupRelativeParticipantsByLockingId: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant?lockingId=${id}&page=1&limit=9999`
      );

      let mappedData = [];
      if (response?.items && response?.items?.length > 0) {
        const list = [...response?.items];
        const members = list.filter((x) => !x.isCollaborator);
        members.forEach((member) => {
          const relatives = list.filter(
            (x) => x.isCollaborator && x.relativeId === member.employeeId
          );
          mappedData.push({ member, relatives });
        });
      }

      return mappedData;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getRelativeParticipantsForCalculateByLockingId: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant?lockingId=${id}&page=1&limit=9999`
      );

      let mappedData = null;
      if (response?.items) {
        mappedData = response?.items.map((item) => ({
          employeeId: item?.employee?._id || "",
          relativeId: item?.relative?._id,
          isCollaborator: item?.isCollaborator,
          workingDays: item?.workingDays || 0,
          commissionRate: item?.commissionRate || 0,
          relativeCommissionRate: item?.relativeCommissionRate || 0,
          businessCategoryCode: item?.employee?.businessCategory?.code,
        }));
      }

      return mappedData;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getManagerRelativeParticipantsForCalculateByLockingId: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant/list/manager?lockingId=${id}&isCollaborator=false&page=1&limit=9999`
      );

      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getInfoLockingId: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant?lockingId=${id}&page=1&limit=9999`
      );

      let mappedData = null;
      if (response?.items) {
        mappedData = response?.items.map((item) => ({
          employee: item?.employee?.fullName || "",
          employeeJobTitle: item?.employeeJobTitle || "",
          commissionRate: item?.commissionRate || "",
        }));
      }

      return mappedData;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  getAttendanceManager: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant/list/attendance?lockingId=${id}`
      );

      // let mappedData = null;
      // if (response?.items) {
      //   mappedData = response?.items.map((item) => ({
      //     fullName: item?.fullName || "",
      //     interpretation: item?.interpretation || "",
      //     fullNameRelative: item?.fullNameRelative || "",
      //     workingDays: item?.workingDays || "0",
      //     isBrokerDebtCertificate: item?.isBrokerDebtCertificate || false,
      //     amountHeld: item?.amountHeld || "0",
      //   }));
      // }
      return response;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  bulk: async (data) => {
    try {
      const response = await clientAPI(
        "post",
        "/lockingRelativeParticipant/manager/bulk",
        data
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  list: async (id) => {
    try {
      const response = await clientAPI(
        "get",
        `/lockingRelativeParticipant/manager/list?lockingId=${id}&page=1&limit=9999`
      );
      let mappedData = null;
      if (response?.items) {
        mappedData = response?.items.map((item) => {
          const data = {
            id: item?._id || "",
            employeeId: item?.employeeId || "",
            commissionRate: item?.commissionRate || "",
            relativeCommissionRate:
              item?.relativeCommissionRate || item?.commissionRate || "",
            employeeJobTitle: item?.employeeJobTitle || "",
            isCollaborator: false,
          };

          if(item?.relativeId) data.relativeId = item.relativeId;
          if(item?.isCollaborator) data.isCollaborator = item.isCollaborator;
          return data;
        });
      }
      return mappedData;
    } catch (error) {
      console.error("update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
};
